export const asNumber = str => str ? Number(str) : undefined

export const csvToArray = csv => csv ? csv.split(',') : []
